<template>
  <div class="grid-x grid-margin-x text-center">
    <div class="cell medium-3">
      <div class="form-group">
        <v-select-kolonne
          id="form-field-kolonne"
          name="kolonne"
          :placeholder="$t('select_all')"
          v-model="item.kolonne"
        />
      </div>
    </div>
    <div class="cell medium-3">
      <div class="form-group">
        <v-datepicker
          class="form-control form-control--small form-control--date"
          :placeholder="$t('search.from')"
          :format="$t('search.from') + ' ' + $helpers.dateFormat"
          :clearButton="true"
          :monday-first="true"
          :disabled-dates="$helpers.disabledDates"
          :language="de"
          v-model="item.startdate"
        />
      </div>
    </div>
    <div class="cell medium-3">
      <div class="form-group">
        <v-datepicker
          class="form-control form-control--small form-control--date"
          :placeholder="$t('search.till')"
          :format="$t('search.till') + ' ' + $helpers.dateFormat"
          :clearButton="true"
          :monday-first="true"
          :disabled-dates="{ days: [6, 0], to : new Date(item.startdate) }"
          :language="de"
          v-model="item.enddate"
        />
      </div>
    </div>
    <div class="cell medium-3">
      <button
        role="button"
        @click.prevent="saveEntry(item)"
        :class="[savesuccess? 'u-animated-saved':'']"
        class="button button--save button--small"
        :title="$t('form.submit.save')"
      >{{ $t('form.submit.save') }}</button>

      <button
        role="button"
        @click.prevent="deleteEntry(item)"
        class="button button--delete"
        :title="$t('delete')"
      >X</button>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { de } from "vuejs-datepicker/dist/locale";
import SelectKolonne from "./../../partials/Forms/SelectKolonne";

export default {
  props: {
    item: {
      type: Object,
      default: () => ({
        kolonne: "",
        startdate: "",
        enddate: ""
      })
    }
  },
  data() {
    return {
      weekplans: [],
      setLayers: [],
      de: de,
      savesuccess: false
    };
  },
  components: {
    vDatepicker: Datepicker,
    vSelectKolonne: SelectKolonne
  },

  mounted: function() {
    this.setScheduledLayersForApi();
  },

  methods: {
    setScheduledLayersForApi: function() {
      if ("project_layers" in this.item) {
        const layers = Object.values(this.item.project_layers);
        layers.forEach(el => {
          if (el.status == "open" || el.status == "busy") {
            this.setLayers.push({
              id: el.id,
              subtype: el.subtype
            });
          }
        });
      }
    },

    saveEntry: function(item) {
      this.savesuccess = false;
      let promise = this.$api.clearParams();

      if (item.id) {
        // already exists
        promise = promise.put("weekplan/" + item.id + "/", item);
      } else {
        // does not exist, create new entry, add layers to dataset
        item.layers = this.setLayers;
        promise = promise.post("weekplan", item);
      }

      return promise
        .then(
          function() {
            this.$emit("onRefresh");
            this.savesuccess = true;
          }.bind(this)
        )
        .catch(function(error) {
          this.savesuccess = false;
          window.app.$helpers.logger(error.response.data.message);
        });
    },
    deleteEntry: function(item) {
      if (!item.id) {
        this.$emit("onRefresh");
        return;
      }
      let promise = this.$api.clearParams().delete("weekplan/" + item.id + "/");
      promise
        .then(
          function() {
            this.$emit("onRefresh");
          }.bind(this)
        )
        .catch(function(error) {
          window.app.$helpers.logger(error.response.data.message);
        });
    }
  }
};
</script>